import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { LegalFooter } from "./LegalFooter";
import { DRAWER_WIDTH } from "./constants";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <TopBar onMenuToggle={() => setMobileOpen((prev) => !prev)} />
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Toolbar sx={{ flexShrink: 0 }} />
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            p: { xs: 2, sm: 3 },
            overflow: "auto",
          }}
        >
          <Outlet />
        </Box>
        <LegalFooter />
      </Box>
    </Box>
  );
}
